export default __webpack_public_path__ + "static/05-22b8a33e5e1af0f360c0fcf1e56f7d1e.jpg";